export default __webpack_public_path__ + "static/home-lg-75cfa1ef57bc3eaef505f3bf06bb1573.png";